(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9201],{

/***/ 66619:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing-biologics",
      function () {
        return __webpack_require__(4163);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Apps_PricingBiologics; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ProductsTab/index.js
var ProductsTab = __webpack_require__(7789);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/PricingSection/index.js
var PricingSection = __webpack_require__(14226);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/index.js + 1 modules
var CardPrice = __webpack_require__(42484);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/Head.js
var Head = __webpack_require__(3221);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/Title.js
var CardPrice_Title = __webpack_require__(14375);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/Description.js
var Description = __webpack_require__(51958);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/Action.js
var Action = __webpack_require__(75800);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/ButtonLink.js
var ButtonLink = __webpack_require__(5322);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 12 modules
var i18 = __webpack_require__(36971);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/CardPrice/Badge.js




const CardPriceBadge = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("card-price-content__badge", className),
        children: children
    });
};
CardPriceBadge.propTypes = {
    children: prop_types.node.isRequired,
    className: prop_types.string
};
/* harmony default export */ var Badge = (CardPriceBadge);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Box/index.js + 1 modules
var Box = __webpack_require__(98746);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 2 modules
var Icon = __webpack_require__(19911);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./src/SiteLayout/index.js
var SiteLayout = __webpack_require__(26485);
// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
// EXTERNAL MODULE: ./src/services/index.js + 11 modules
var services = __webpack_require__(69549);
// EXTERNAL MODULE: ./src/BiologicsHeader/index.js
var BiologicsHeader = __webpack_require__(79048);
;// CONCATENATED MODULE: ./src/Apps/PricingBiologics/index.js
































const PricingBiologics = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("pricing-biologics");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        isWrapper: false,
        HeaderComponent: BiologicsHeader/* default */.Z,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                    href: t("META.CANONICAL")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                utility: {
                    bgColor: "white"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    children: t("HERO.TITLE")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                utility: {
                    bgColor: "4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    utility: {
                        bgColor: "white"
                    },
                    spacing: {
                        pt: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab/* default */.Z, {
                                            logoIcon: "/images/geneious/logo/icon-prime.svg",
                                            borderColor: "3",
                                            title: t("TABS.TAB_1.TITLE"),
                                            description: t("TABS.TAB_1.DESCRIPTION"),
                                            href: "/pricing/"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab/* default */.Z, {
                                            logoIcon: "/images/geneious/logo/icon-biologics.svg",
                                            borderColor: "dotmatics-7",
                                            title: t("TABS.TAB_2.TITLE"),
                                            description: t("TABS.TAB_2.DESCRIPTION"),
                                            active: true
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PricingSection/* default */.Z, {
                isSeparated: false,
                utility: {
                    bgColor: "4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSection/* default.Header */.Z.Header, {
                        title: t("FIRST_SECTION.TITLE"),
                        children: t("FIRST_SECTION.DESCRIPTION")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        mx: true,
                        className: "mt-16 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PricingSection/* default.Body */.Z.Body, {
                                lgCellWidth: 12,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSection/* default.Body.Item */.Z.Body.Item, {
                                        md: 6,
                                        lg: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice/* default */.Z, {
                                            contentProps: {
                                                spacing: {
                                                    lg: {
                                                        px: 6
                                                    }
                                                }
                                            },
                                            className: "mb-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice_Title/* default */.Z, {
                                                        children: t("FIRST_SECTION.STARTER.TITLE")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description/* default */.Z, {
                                                        align: "left",
                                                        className: "min-h-44--md",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m",
                                                                    fontColor: "black--custom-1"
                                                                },
                                                                children: t("FIRST_SECTION.STARTER.DESCRIPTION")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m",
                                                                    fontWeight: "bold"
                                                                },
                                                                children: t("FIRST_SECTION.STARTER.COST")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                            styleType: "primary",
                                                            href: "https://annotator.geneious.com/sign-up",
                                                            children: t("FIRST_SECTION.STARTER.BUTTON_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                                        sx: {
                                                            textAlign: "left"
                                                        },
                                                        spacing: {
                                                            mt: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m",
                                                                    fontWeight: "bold"
                                                                },
                                                                children: t("FIRST_SECTION.STARTER.INCLUDED.TITLE")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                                type: "pros",
                                                                spacing: {
                                                                    sm: {
                                                                        mb: 8
                                                                    },
                                                                    md: {
                                                                        mb: 0
                                                                    }
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.STARTER.INCLUDED.ITEM_1")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.STARTER.INCLUDED.ITEM_2")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.STARTER.INCLUDED.ITEM_3")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.STARTER.INCLUDED.ITEM_4")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.STARTER.INCLUDED.ITEM_5")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSection/* default.Body.Item */.Z.Body.Item, {
                                        md: 6,
                                        lg: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice/* default */.Z, {
                                            contentProps: {
                                                spacing: {
                                                    lg: {
                                                        px: 6
                                                    }
                                                }
                                            },
                                            className: "mb-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice_Title/* default */.Z, {
                                                        children: t("FIRST_SECTION.PERSONAL.TITLE")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description/* default */.Z, {
                                                        align: "left",
                                                        className: "min-h-44--md",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m",
                                                                    fontColor: "black--custom-1"
                                                                },
                                                                children: t("FIRST_SECTION.PERSONAL.DESCRIPTION")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m"
                                                                },
                                                                spacing: {
                                                                    my: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                                                                        sx: {
                                                                            fontWeight: "bold"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.COST.ITEM_1.COST")
                                                                    }),
                                                                    " ",
                                                                    t("FIRST_SECTION.PERSONAL.COST.ITEM_1.TYPE")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m"
                                                                },
                                                                spacing: {
                                                                    my: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                                                                        sx: {
                                                                            fontWeight: "bold"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.COST.ITEM_2.COST")
                                                                    }),
                                                                    " ",
                                                                    t("FIRST_SECTION.PERSONAL.COST.ITEM_2.TYPE")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                            styleType: "primary",
                                                            href: "/biopharma/purchase-annual/",
                                                            children: t("FIRST_SECTION.PERSONAL.BUTTON_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                                        sx: {
                                                            textAlign: "left"
                                                        },
                                                        spacing: {
                                                            mt: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "m",
                                                                    fontWeight: "bold"
                                                                },
                                                                children: t("FIRST_SECTION.PERSONAL.INCLUDED.TITLE")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                                type: "pros",
                                                                spacing: {
                                                                    sm: {
                                                                        mb: 8
                                                                    },
                                                                    md: {
                                                                        mb: 0
                                                                    }
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_1")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_2")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_3")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_4")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                        sx: {
                                                                            fontColor: "black--custom-1"
                                                                        },
                                                                        children: t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_5")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSection/* default.Body.Item */.Z.Body.Item, {
                                        md: 6,
                                        lg: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardPrice/* default */.Z, {
                                            contentProps: {
                                                spacing: {
                                                    lg: {
                                                        px: 6
                                                    }
                                                }
                                            },
                                            className: "mb-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                                    className: "bg-color-dotmatics-7 px-4 py-1 text-color-white",
                                                    children: t("FIRST_SECTION.GROUP.BAGE")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice_Title/* default */.Z, {
                                                            children: t("FIRST_SECTION.GROUP.TITLE")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description/* default */.Z, {
                                                            align: "left",
                                                            className: "min-h-44--md",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "m",
                                                                        fontColor: "black--custom-1"
                                                                    },
                                                                    children: t("FIRST_SECTION.GROUP.DESCRIPTION")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "m"
                                                                    },
                                                                    spacing: {
                                                                        my: 0
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                                                                        sx: {
                                                                            fontWeight: "bold"
                                                                        },
                                                                        children: t("FIRST_SECTION.GROUP.COST")
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                                styleType: "primary",
                                                                href: "/biopharma/contact-us/",
                                                                children: t("FIRST_SECTION.GROUP.BUTTON_TEXT")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                                            sx: {
                                                                textAlign: "left"
                                                            },
                                                            spacing: {
                                                                mt: 6
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "m",
                                                                        fontWeight: "bold"
                                                                    },
                                                                    children: t("FIRST_SECTION.GROUP.INCLUDED.TITLE")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                                    type: "pros",
                                                                    spacing: {
                                                                        sm: {
                                                                            mb: 8
                                                                        },
                                                                        md: {
                                                                            mb: 0
                                                                        }
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                            sx: {
                                                                                fontColor: "black--custom-1"
                                                                            },
                                                                            children: t("FIRST_SECTION.GROUP.INCLUDED.ITEM_1")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                            sx: {
                                                                                fontColor: "black--custom-1"
                                                                            },
                                                                            children: t("FIRST_SECTION.GROUP.INCLUDED.ITEM_2")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                            sx: {
                                                                                fontColor: "black--custom-1"
                                                                            },
                                                                            children: t("FIRST_SECTION.GROUP.INCLUDED.ITEM_3")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
                isBorderNone: true,
                className: "pt-0 pb-0",
                utility: {
                    bgColor: "4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                        mx: true,
                        px: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "xxxl"
                                            },
                                            children: t("SECOND_SECTION.ITEM_1.TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "black--custom-1"
                                            },
                                            children: t("SECOND_SECTION.ITEM_1.DESCRIPTION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                href: "/biopharma/purchase-quarterly/",
                                                sx: {
                                                    fontColor: "black"
                                                },
                                                children: [
                                                    t("SECOND_SECTION.ITEM_1.LINK_TEXT"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        name: "angle-right",
                                                        color: "3"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "xxxl"
                                            },
                                            children: t("SECOND_SECTION.ITEM_2.TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "black--custom-1"
                                            },
                                            children: t("SECOND_SECTION.ITEM_2.DESCRIPTION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                href: "/biopharma/request-demo/",
                                                sx: {
                                                    fontColor: "black"
                                                },
                                                children: [
                                                    t("SECOND_SECTION.ITEM_2.LINK_TEXT"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        name: "angle-right",
                                                        color: "3"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "xxxl"
                                            },
                                            children: t("SECOND_SECTION.ITEM_3.TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "black--custom-1"
                                            },
                                            children: t("SECOND_SECTION.ITEM_3.DESCRIPTION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                href: "/biopharma/contact-us/",
                                                sx: {
                                                    fontColor: "black"
                                                },
                                                children: [
                                                    t("SECOND_SECTION.ITEM_3.LINK_TEXT"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        name: "angle-right",
                                                        color: "3"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
                isBorderNone: true,
                utility: {
                    bgColor: "4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            md: 10,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontColor: "black--custom-2",
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                    Tag: "span",
                                    children: t("SECOND_SECTION.ANNOTATE", {
                                        linkLicense: "https://assets.geneious.com/legal/geneious-terms-of-service.pdf",
                                        linkContact: "/biopharma/contact-us/"
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
                utility: {
                    bgColor: "4"
                },
                isFluid: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    center: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        sm: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                            utility: {
                                border: {
                                    bottom: {
                                        width: 1,
                                        color: "black--15"
                                    }
                                }
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
                bgColor: "4",
                isBorderNone: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 15
                        },
                        children: t("FAQ.TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                mx: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    sx: {
                                                        fontSize: "l",
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("FAQ.ITEM_1.QUESTION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("FAQ.ITEM_1.ANSWER_1", {
                                                            link: "https://annotator.geneious.com/",
                                                            linkTry: "https://www.geneious.com/biopharma/request-demo/"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    sx: {
                                                        fontSize: "l",
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("FAQ.ITEM_2.QUESTION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: t("FAQ.ITEM_2.ANSWER_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: t("FAQ.ITEM_2.ANSWER_2")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    sx: {
                                                        fontSize: "l",
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("FAQ.ITEM_3.QUESTION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("FAQ.ITEM_3.ANSWER_1", {
                                                            link: "https://www.geneious.com/biopharma/features/data-security/"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                mx: true,
                                spacing: {
                                    mt: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    sx: {
                                                        fontSize: "l",
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("FAQ.ITEM_4.QUESTION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("FAQ.ITEM_4.ANSWER_1", {
                                                            linkData: "https://www.geneious.com/biopharma/features/data-security/",
                                                            linkContact: "https://www.geneious.com/biopharma/contact-us/"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    sx: {
                                                        fontSize: "l",
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("FAQ.ITEM_5.QUESTION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("FAQ.ITEM_5.ANSWER_1", {
                                                            link: "https://www.geneious.com/biopharma/request-demo/"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    sx: {
                                                        fontSize: "l",
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("FAQ.ITEM_6.QUESTION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    Tag: "div",
                                                    spacing: {
                                                        mt: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("FAQ.ITEM_6.ANSWER_1", {
                                                            link: "https://www.geneious.com/biopharma/contact-us/"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Apps_PricingBiologics = ((0,pipe/* default */.Z)(PricingBiologics, withErrorHandling/* default */.Z, services/* default */.Z));

;// CONCATENATED MODULE: ./pages/pricing-biologics.js



/***/ }),

/***/ 98746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Box/Box.js








const Box = (param)=>/*#__PURE__*/ {
    let { className ="" , borderRadius , borderWidth , borderColor , bgColor , indent =false , shadow =false , overflow , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , children , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("box", indent && "box--indent", overflow && "overflow--".concat(overflow), shadow && "box--shadow", ...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            bgColor,
            radius: borderRadius,
            border: {
                width: borderWidth,
                color: borderColor
            }
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Box.propTypes = {
    className: prop_types.string,
    borderRadius: prop_types.number,
    borderWidth: (0,prop_types.oneOf)([
        1,
        2,
        3,
        4
    ]),
    borderColor: prop_types.string,
    bgColor: prop_types.string,
    overflow: (0,prop_types.oneOf)([
        "hidden"
    ]),
    indent: prop_types.bool,
    shadow: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Box_Box = (Box);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Box/index.js



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7959,8529,762,6436,9549,4096,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(66619); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);